
const routes = [
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js